import { render, staticRenderFns } from "./MenuTypeAdmin.vue?vue&type=template&id=4251efc4&scoped=true"
import script from "./MenuTypeAdmin.vue?vue&type=script&lang=js"
export * from "./MenuTypeAdmin.vue?vue&type=script&lang=js"
import style0 from "./MenuTypeAdmin.vue?vue&type=style&index=0&id=4251efc4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4251efc4",
  null
  
)

export default component.exports